import Duration from "../duration.js";
function dayDiff(earlier, later) {
  const utcDayStart = (dt) => dt.toUTC(0, { keepLocalTime: !0 }).startOf("day").valueOf(), ms = utcDayStart(later) - utcDayStart(earlier);
  return Math.floor(Duration.fromMillis(ms).as("days"));
}
function highOrderDiffs(cursor, later, units) {
  const differs = [
    ["years", (a, b) => b.year - a.year],
    ["quarters", (a, b) => b.quarter - a.quarter + (b.year - a.year) * 4],
    ["months", (a, b) => b.month - a.month + (b.year - a.year) * 12],
    [
      "weeks",
      (a, b) => {
        const days = dayDiff(a, b);
        return (days - days % 7) / 7;
      }
    ],
    ["days", dayDiff]
  ], results = {}, earlier = cursor;
  let lowestOrder, highWater;
  for (const [unit, differ] of differs)
    units.indexOf(unit) >= 0 && (lowestOrder = unit, results[unit] = differ(cursor, later), highWater = earlier.plus(results), highWater > later ? (results[unit]--, cursor = earlier.plus(results), cursor > later && (highWater = cursor, results[unit]--, cursor = earlier.plus(results))) : cursor = highWater);
  return [cursor, results, highWater, lowestOrder];
}
function diff(earlier, later, units, opts) {
  let [cursor, results, highWater, lowestOrder] = highOrderDiffs(earlier, later, units);
  const remainingMillis = later - cursor, lowerOrderUnits = units.filter(
    (u) => ["hours", "minutes", "seconds", "milliseconds"].indexOf(u) >= 0
  );
  lowerOrderUnits.length === 0 && (highWater < later && (highWater = cursor.plus({ [lowestOrder]: 1 })), highWater !== cursor && (results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor)));
  const duration = Duration.fromObject(results, opts);
  return lowerOrderUnits.length > 0 ? Duration.fromMillis(remainingMillis, opts).shiftTo(...lowerOrderUnits).plus(duration) : duration;
}
export {
  diff as default
};
//# sourceMappingURL=diff.js.map
